module.exports = __webpack_public_path__ + "img/MDI-message-question-disabled.dc08f2b6.svg";